import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getDimension,
  getParticularPage,
  getNext,
  getPrevious,
  createDimension,
  updateDimension,
  handleSearch,
} from "./thunk";

const initialState = {
  dimensions: [],
  edit: false,
  dimension: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingDimension: false,
  loadingNext: false,
  showCreateModal: false,
};

export const dimensionSlice = createSlice({
  name: "dimension",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    dimensionEditSuccess: (state, action) => {
      state.edit = true;
      state.dimension = state.dimensions.find((dimension) => dimension.id === action.payload);
    },
    clearAllDimension: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingDimension = false;
      state.dimension = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createDimension.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createDimension.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createDimension.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateDimension.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateDimension.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateDimension.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getDimension.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingDimension = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDimension.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingDimension = false;
        state.dimensions = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDimension.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingDimension = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, dimensionEditSuccess, clearAllDimension } = dimensionSlice.actions;

export default dimensionSlice.reducer;
